<!-- <div [@routeAnimation]="getRouteState(outlet)"> -->

<router-outlet></router-outlet>
<!-- </div> -->
